import React from 'react'
import {Card, CardContent, Grid, Typography } from '@material-ui/core'
import styles from './Cards.module.css'
import CountUp from 'react-countup'
import cx from 'classnames'

const Cards = ({data: {confirmed, recovered, deaths, lastUpdate}}) => {
    if(!confirmed || confirmed == null){
        return '..Loading'
    }

    return(
        <div className={styles.container}>
            
            <Grid container spacing={3} justify="center">
                <Grid item component={Card} xs={12} className={cx(styles.card, styles.infected)}>
                    <CardContent>
                        <Typography color="textSecondary" gutterBottom>
                        Infected
                        </Typography>
                        <Typography variant="h5">
                            <CountUp 
                            start={0}
                            end={confirmed.value}
                            duration={2.5}
                            separator=","
                            />
                        </Typography>
                        <Typography color="textSecondary">
                            {new Date(lastUpdate).toDateString()}
                        </Typography>
                        <Typography variant="body2">Number of Active Cases Of COVID19</Typography>
                    </CardContent>
                </Grid>

                <Grid item component={Card} xs={12} className={cx(styles.card, styles.recovered)}>
                    <CardContent>
                        <Typography color="textSecondary" gutterBottom>
                        Recovered
                        </Typography>
                        <Typography variant="h5">
                            <CountUp 
                            start={0}
                            end={recovered.value}
                            duration={2.5}
                            separator=","
                            />
                        </Typography>
                        <Typography color="textSecondary">
                        {new Date(lastUpdate).toDateString()}
                        </Typography>
                        <Typography variant="body2">Number of Recoveries</Typography>
                    </CardContent>
                </Grid>
            
                <Grid item component={Card} xs={12} className={cx(styles.card, styles.death)}>
                    <CardContent>
                        <Typography color="textSecondary" gutterBottom>
                        Deaths
                        </Typography>
                        <Typography variant="h5">
                        {new Date(lastUpdate).toDateString()}
                        </Typography>
                        <Typography variant="h5">
                            <CountUp 
                            start={0}
                            end={deaths}
                            duration={2.5}
                            separator=","
                            />
                        </Typography>
                        <Typography variant="body2">Number of Deaths caused by COVID19</Typography>
                    </CardContent>
                </Grid>
                
            </Grid>
        </div>
    )
}

export default Cards